import Vue from "vue";

const i18n = {
  install(Vue) {
    // Add placeholder $t global functions to add translation when needed.
    Vue.prototype.$t = (string, pluralString = null, amount = 1) =>
      amount > 1 ? pluralString : string;
  }
};

Vue.use(i18n);
